import DataValue from "../DataValue"

export interface ProRataData {
	allowance: DataValue,
	days?: number | undefined
	notes?: string | undefined
}